import React from "react";
import "./Styles/sectionFour.css";
import Banner2 from "../Banners/2.png";
export default function SectionFour() {
  return (
    <div className="sectionFour">
      <div>
        <img src={Banner2} />
      </div>
    </div>
  );
}
